import { batch, connect } from 'react-redux';
import { Dispatch } from 'redux';

import { actions as productImagesCarouselActions } from 'src/components/organisms/ProductImagesCarousel';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/selectors';
import { ProductDescription } from '../components/ProductDescription';
import { onExpandProductDescriptionToggle } from '../modules';

const mapStateToProps = (state: ReduxApplicationState) => ({
  product: selectProduct(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleThumbnailClick: (imageIndex: number) => {
    batch(() => {
      dispatch(
        productImagesCarouselActions.setCurrentImage({ imageIndex, navigationType: 'click' }),
      );
      dispatch(productImagesCarouselActions.openModal({ location: 'Carousel' }));
    });
  },
  onExpandProductDescriptionToggle: (isOpen: boolean) =>
    dispatch(onExpandProductDescriptionToggle(isOpen)),
});

export const ProductDescriptionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductDescription);
